export const CONSUL_LIST_REQUEST = "CONSUL_LIST_REQUEST";
export const CONSUL_LIST_SUCCESS = "CONSUL_LIST_SUCCESS";
export const CONSUL_LIST_FAIL = "CONSUL_LIST_FAIL";

export const CONSUL_ADD_REQUEST = "CONSUL_ADD_REQUEST";
export const CONSUL_ADD_SUCCESS = "CONSUL_ADD_SUCCESS";
export const CONSUL_ADD_FAIL = "CONSUL_ADD_FAIL";
export const CONSUL_ADD_RESET = "CONSUL_ADD_RESET";

export const CONSUL_DETAILS_REQUEST = "CONSUL_DETAILS_REQUEST";
export const CONSUL_DETAILS_SUCCESS = "CONSUL_DETAILS_SUCCESS";
export const CONSUL_DETAILS_FAIL = "CONSUL_DETAILS_FAIL";

export const CONSUL_UPDATE_REQUEST = "CONSUL_UPDATE_REQUEST";
export const CONSUL_UPDATE_SUCCESS = "CONSUL_UPDATE_SUCCESS";
export const CONSUL_UPDATE_FAIL = "CONSUL_UPDATE_FAIL";
export const CONSUL_UPDATE_RESET = "CONSUL_UPDATE_RESET";

export const CONSUL_DELETE_REQUEST = "CONSUL_DELETE_REQUEST";
export const CONSUL_DELETE_SUCCESS = "CONSUL_DELETE_SUCCESS";
export const CONSUL_DELETE_FAIL = "CONSUL_DELETE_FAIL";
